import { render, staticRenderFns } from "./SideMenuCli.vue?vue&type=template&id=3386ccaa&scoped=true&"
import script from "./SideMenuCli.vue?vue&type=script&lang=js&"
export * from "./SideMenuCli.vue?vue&type=script&lang=js&"
import style0 from "./SideMenuCli.vue?vue&type=style&index=0&id=3386ccaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3386ccaa",
  null
  
)

export default component.exports